import { defineComponent } from 'vue';

import SortContainer from './SortContainer.class';

export default defineComponent({
	setup: () => {
		const component = new SortContainer();

		return {
			sortingOptions: component.sortingOptions,
			isSelected: component.isSelected.bind(component),
			select: component.select.bind(component)
		};
	}
});
